import { useQuery } from '@tanstack/react-query';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import GetIdVerificationSessionUseCase from 'src/features/verification/domain/useCases/GetIdVerificationSessionUseCase';
import { diContainer } from 'src/inversify.config';

const getIdVerificationSessionUseCase = diContainer.get(
  GetIdVerificationSessionUseCase
);

export default function useIdVerification() {
  const { session } = useAuthContext();

  const accessToken = session?.accessToken;

  const query = useQuery({
    queryKey: ['idVerification', accessToken],
    queryFn: () =>
      getIdVerificationSessionUseCase.execute({ token: accessToken! }),
  });

  return query;
}
